import { render, staticRenderFns } from "./PageEditorFooter.vue?vue&type=template&id=81584e30&scoped=true"
import script from "./PageEditorFooter.js?vue&type=script&lang=js&external"
export * from "./PageEditorFooter.js?vue&type=script&lang=js&external"
import style0 from "./PageEditorFooter.scss?vue&type=style&index=0&id=81584e30&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81584e30",
  null
  
)

export default component.exports